
export const cast = <T>(value: unknown): T | Promise<T> =>
  (
    value instanceof Promise
      ? value as Promise<T>
      : value as T
  );

export const throwError = (message: string): never => {
  throw new Error(message);
};

export const throwContextError = (name: string) => {
  throwError(`Using '${name}' out of provider scope`);
};
